import { CdnUrl } from "../../../common/constants";
import { combineAddress, getDotaTextWithReplaces } from "../../../common/utils";

export const ItemBuildImage: React.FC<{
    className?: string
    name: string
}> = ({ className, name }) => {
    const src = combineAddress(CdnUrl, `/v2/images/dota-items/${name}.png`)
    return <img className={`items-center
            ${name.includes('aghsstatus_shard') ? 'h-[24px] 2xl:h-[34px]' : 'h-[40px] 2xl:h-[55px]'}  
            ${name.includes('aghsstatus') ? 'w-[35px] 2xl:w-[50px]' : 'w-[60px] 2xl:w-[80px] shadow-[1px_1px_5px_1px_rgba(0,0,0,0.57)]'}  
            ${className ?? ''} `} src={src} alt=''
    />
}

export const ItemUpdateImage: React.FC<{
    className?: string
    name: string
}> = ({ className, name }) => {
    const src = combineAddress(CdnUrl, `/v2/images/dota-items/${name}.png`)
    return <img className={`items-center h-[40px] lg:w-[72px] lg:h-[52px] ${className ?? ''} `} src={src} alt=''
    />
}

export const MapImage: React.FC<{
    className?: string
    isDuo: boolean
}> = ({ className, isDuo }) => {
    const src = combineAddress(CdnUrl, `/v2/images/maps/minimap${isDuo ? '_duo' : ''}.png`)
    return <img className={`items-center ${className ?? ''} `} src={src} alt=''
    />
}

export const HeroIconImage: React.FC<{
    className?: string
    name: string
}> = ({ className, name }) => {
    const src = combineAddress(CdnUrl, `/v2/images/hero-icons/${name}.png`)
    return <img className={`items-center ${className ?? ''} `} src={src} alt=''
    />
}

export const ItemImage: React.FC<{
    className?: string
    name: string
}> = ({ className, name }) => {
    const src = combineAddress(CdnUrl, `/v2/images/dota-items/${name.replace('item_', '')}.png`)
    return <img className={`items-center ${className ?? ''} `} src={src} alt=''
    />
}

export const ItemBuildsUnsubImage: React.FC<{
    className?: string
}> = ({ className }) => {
    const src = combineAddress(CdnUrl, `/v2/images/bg/builds_unsub.png`)
    return <img className={`items-center ${className ?? ''} `} src={src} alt=''
    />
}

export const BuildingImage: React.FC<{
    className?: string
    type: string
}> = ({ className, type }) => {
    const src = combineAddress(CdnUrl, `/v2/images/builds/${type}.png`)
    return <img className={`items-center ${className ?? ''} `} src={src} alt=''
    />
}

export const AghanimImage: React.FC<{
    className?: string
    type: 'scepter' | 'shard'
}> = ({ className, type }) => {
    const imageName = type == 'scepter' ? 'aghsstatus_scepter_on' : 'aghsstatus_shard_on'
    const defaultSize = type == 'scepter' ? 'h-[32px] w-[32px]' : 'h-[22px] w-[39px]'

    const src = combineAddress(CdnUrl, `/v2/images/dota-items/${imageName}.png`)
    return <div className="w-[40px] h-[40px] flex justify-center items-center">
        <img className={`${defaultSize} ${className ?? ''} `} alt='' src={src} />
    </div>
}

export const InnateImage: React.FC<{
    className?: string
}> = ({ className }) => {
    const src = combineAddress(CdnUrl, `/v2/images/dota-items/innate.png`)
    return <div className={`flex justify-center items-center ${className}`}>
        <img className={`h-full`} alt='' src={src} />
    </div>
}

export const UpgradeImage: React.FC<{
    className?: string
    imgClassName?: string
    type: string
}> = ({ className, type, imgClassName }) => {
    let imageName;
    switch (type) {
        case 'Scepter':
            imageName = 'ultimate_scepter'
            break;
        case 'Shard':
            imageName = 'aghanims_shard'
            break;
        case 'Innate':
            imageName = 'innate'
            break;
        default:
            imageName = type
            break;
    }

    const src = combineAddress(CdnUrl, `/v2/images/dota-items/${imageName}.png`)
    return <div className={`flex justify-center items-center ${className ?? ''}`}>
        <img className={`h-[40px] lg:h-[52px] ${imgClassName || ''} `} alt='' src={src} />
    </div>
}

export const BackgroundVideo: React.FC<{
    videoSrc: string,
    className?: string
}> = ({ videoSrc, className }) => {
    return (
        <div>
            <video
                className={`absolute top-0 left-0 w-full object-cover z-[-1] h-[700px] ${className || ''}`}
                src={combineAddress(CdnUrl, videoSrc)}
                autoPlay
                loop
                muted
                playsInline
            >
            </video>
            <div className={`absolute top-0 left-0 w-full z-[-1] pointer-events-none h-[700px] ${className || ''}`}
                style={{
                    background: 'linear-gradient(to bottom, rgb(17, 31, 42, 0.05), rgb(5, 10, 13) 100%)'
                }}
            />
        </div>
    );
};

export const DotaPlusVideo: React.FC<{
    number: number,
    className?: string
}> = ({ number, className }) => {
    return <div className="relative lg:static shadow-white-l">
        <div className="absolute inset-0 bg-black/50 lg:hidden" />
        <video
            className={` ${className || ''}`}
            src={combineAddress(CdnUrl, `/v2/videos/dota-plus-${number}.mp4`)}
            autoPlay
            loop
            muted
            playsInline
        />
    </div>
}

export const HeroImage: React.FC<{
    className?: string
    heroName: string,
    size: '80x47' | '136x78' | '146x82' | '178x100' | '187x107' | '222x125' | 'base'
}> = ({ heroName, size, className }) => {

    const src = combineAddress(CdnUrl, `/v2/images/heroes/${heroName}/${size}.png`)
    return <img className={`${className ?? ''} `} src={src} alt={''} />
}

export const HeroAttributeImage: React.FC<{
    className?: string
    attr: string,
}> = ({ attr, className }) => {
    return <img
        className={`${className || ''}`}
        src={`/images/${attr}-active.png`}
    />
}


export const TalentImage: React.FC<{
    className?: string
    name?: string,
    dataTooltipHtml?: string
    dataTooltipId?: string
    size: '47x47' | '100x100' | '72x72' | 'base'
}> = ({ name, size, className, dataTooltipHtml, dataTooltipId }) => {
    if (!name)
        return <></>

    const src = combineAddress(CdnUrl, `/v2/images/talents/${name.toLocaleLowerCase()}/${size}.png`)
    return <img className={`${className ?? ''} `} src={src} alt={''} data-tooltip-id={dataTooltipId || ''} data-tooltip-html={dataTooltipHtml || ''} />
}

export const TalentSharedImage: React.FC<{
    className?: string
    path: string,
    heroName: string
    dataTooltipHtml?: string
    dataTooltipId?: string
}> = ({ heroName, path, dataTooltipHtml, dataTooltipId, className }) => {
    const imgPath = path.includes('innate') ? 'general_changes/innate' : `${heroName}/${path.toLowerCase()}`

    const src = combineAddress(CdnUrl, `/shared/images/icons/mini/${imgPath}_png.png`)
    return <div className={className || ""} data-tooltip-id={dataTooltipId || ''} data-tooltip-html={getDotaTextWithReplaces(dataTooltipHtml) || ''}>
        <img src={src} alt={''} />
    </div>
}

export const TalentLevelSharedImage: React.FC<{
    className?: string
    path: string,
    heroName: string
    dataTooltipHtml?: string
    dataTooltipId?: string
}> = ({ heroName, path, dataTooltipHtml, dataTooltipId, className }) => {
    const src = combineAddress(CdnUrl, `/shared/images/icons/mini/${heroName}/${path.toLowerCase()}_png.png`)
    return <div className={className || ""} data-tooltip-id={dataTooltipId || ''} data-tooltip-html={dataTooltipHtml || ''}>
        <img src={src} />
    </div>
}

export const SizedImage: React.FC<{
    src?: string,
    templateIfSrcEmpty?: string,
    className?: string,
    templateClassName?: string,
    imgClassName?: string,
    imgWitoutFull?: boolean,
    alt?: string,
    fromCdn?: boolean
    dataTooltipHtml?: string
    dataTooltipId?: string
}> = props => {

    const src = props.src
        ? props.fromCdn
            ? `${combineAddress(CdnUrl, props.src)}`
            : props.src
        : props.templateIfSrcEmpty;

    return <div className={props.className || ""} data-tooltip-id={props.dataTooltipId || ''} data-tooltip-html={props.dataTooltipHtml || ''}>
        <img
            className={`${props.imgClassName || " "} ${props.imgWitoutFull ? ' ' : ' h-full '}`}
            src={src}
            alt={props.alt || ""}
        />
    </div>
}

export const ProductImage: React.FC<{
    className?: string
    imgClassName?: string
    name: string
}> = ({ name, className, imgClassName }) => {
    const src = combineAddress(CdnUrl, `/v2/images/products/${name}.png`)
    return <div className={className || ""}>
        <img className={`${imgClassName || ''}`} src={src} />
    </div>
}

export const SadTinyImage: React.FC<{
    className?: string
    imgClassName?: string
}> = ({ className, imgClassName }) => {
    const src = combineAddress(CdnUrl, `/v2/images/bg/sad-tiny.png`)
    return <div className={className || ""}>
        <img className={`${imgClassName || ''}`} src={src} />
    </div>
}


export const PaymentImage: React.FC<{
    className?: string
    imgClassName?: string
    name: string
}> = ({ name, className, imgClassName }) => {
    const src = combineAddress(CdnUrl, `/v2/images/payments/${name}.png`)
    return <div className={className || ""}>
        <img className={`${imgClassName || ''}`} src={src} />
    </div>
}

export const BackgroundImage: React.FC<{
    src: string;
    className?: string;
    fromCdn?: boolean;
}> = ({ src, className = '', fromCdn }) => {
    const imgSrc = fromCdn ? combineAddress(CdnUrl, src) : src;
    return (
        <div>
            <div
                className={`absolute top-0 left-0 w-full h-[597px] z-[-1] ${className}`}
                style={{
                    backgroundImage: `url('` + imgSrc + `')`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover'
                }}
            />
            {/* <div className={`absolute top-0 left-0 w-full z-[-1] pointer-events-none h-[597px] ${className || ''}`}
                style={{
                    background: 'linear-gradient(to bottom, rgb(17, 31, 42, 0.05), rgb(5, 10, 13) 100%)'
                }}
            /> */}
        </div>
    );
};





